import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import VendorsTab from "./VendorsTab";
import VendorCategoryTab from "./VendorCategoryTab";
import AccommodationTab from "./AccommodationTab";
import { NoAccess } from "../equipment/shared/NoAccess";

const ALL_ROLES = ["Director", "Manager", "Accounts", "Back Office"];

const TABS = [
  { key: "vendors", label: "Vendors", Component: VendorsTab },
  { key: "categories", label: "Vendor Category", Component: VendorCategoryTab },
  { key: "accommodation", label: "Accommodation", Component: AccommodationTab },
];

// Vendor Master — standalone module (Mar 2026), lives in the BUSINESS nav
// group directly above Payment Desk. Director/Manager/Back Office get
// full CRUD; Accounts is view-only on both tabs.
export default function VendorMasterPage() {
  const { user } = useAuth();
  const [active, setActive] = useState(TABS[0].key);

  if (!ALL_ROLES.includes(user?.role)) return <NoAccess />;

  return (
    <div className="space-y-6" data-testid="vendor-master-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
          Vendor Master
        </h1>
        <p className="text-sm text-slate-500">Vendor records and categories shared across Payment Desk.</p>
      </div>
      <Tabs value={active} onValueChange={setActive}>
        <TabsList className="flex-wrap h-auto">
          {TABS.map((t) => (
            <TabsTrigger key={t.key} value={t.key} data-testid={`vendor-master-tab-${t.key}`}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {TABS.map((t) => (
          <TabsContent key={t.key} value={t.key} className="pt-4">
            <t.Component />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
